<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/system-users"
                :searchArgs="searchArgs">

            <slot slot="afterList">

            </slot>

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/system-users"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'id'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'status'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'firstname'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'lastname'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'email'
                                                    }
                                                ]
                                            },
                                            {
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'id',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('ID'),
                                        value: true,
                                        export: 'id',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'status',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('État'),
                                        value: true,
                                         export: 'status',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'firstname',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Prénom'),
                                        value: true,
                                         export: 'firstname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'lastname',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom de famille'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'lastname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'email',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Courriel'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'email',
                                        onChange: function() {}
                                    }
                                ]}"

                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>
    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import ModalExport from '../../../../components/ModalExport'
    export default {
        name: 'ReportSystemUser',
        components: {
            DynamicList,
            ModalExport
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'firstname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom de famille'),
                        key: 'lastname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Courriel'),
                        key: 'email',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Téléphone'),
                        key: 'phone',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Rôle'),
                        type: 'select',
                        key: 'userRole',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'email'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'phone'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'branch'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'number',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'firstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'phone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'email',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        },
                        {
                            id: 'branch',
                            type: 'select',
                            multiple: false,
                            label: Core.Definition.getDefinition('Succursale'),
                            value: null,
                            onSelect: function() {}
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataCharts: false
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
              if(data !== undefined && data.charts !== undefined) {
                  this.dataCharts = data.charts
              }
            },
            clickEdit(value, cell, row) {
                this.$router.push('/systeme/utilisateurs/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
